import { render, staticRenderFns } from "./vivaCenterAllocation.vue?vue&type=template&id=672c4c84&"
import script from "./vivaCenterAllocation.vue?vue&type=script&lang=js&"
export * from "./vivaCenterAllocation.vue?vue&type=script&lang=js&"
import style0 from "./vivaCenterAllocation.vue?vue&type=style&index=0&id=672c4c84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports